



























































import Vue from 'vue'
import InstallDevice from '@/components/InstallDevices/InstallDevice.vue'
import RecentEntities from '@/components/InstallDevices/RecentEntities.vue'
import UnderlineTextButton from '@/components/Global/UnderlineTextButton.vue'
import InfoGuideDialog from '@/components/Global/InfoGuideDialog.vue'
import { isMobile } from '@/helpers/mixins'
import { portalState } from '@/state'
import FreeDevices from '@/components/Global/FreeDevices.vue'

export default Vue.extend({
  name: 'InstallDevices',
  components: { FreeDevices, UnderlineTextButton, InstallDevice, RecentEntities, InfoGuideDialog },
  computed: {
    currentLocale () {
      return this.$vuetify.lang.current
    },
    hasCustomers () {
      return portalState.user.businesses.some((b: { has_customers: boolean }) => b.has_customers)
    },
  },
  data () {
    return {
      replaceDeviceMode: false,
      infoGuideDialogOpened: false,
      showNotice: true
    }
  },
  mounted () {
    if (isMobile()) {
      this.$router.push({ path: 'install-devices-mobile' })
    }
  }
})
